import React, { forwardRef, useImperativeHandle, useRef, useEffect, useState } from "react";
import ComponentTagSelector from "../tags/ComponentTagSelector";

// import { useUserTypes } from "../../context/UserTypeContext.jsx";
import { useMasterData } from "../../context/MasterDataContext.jsx";



const Comp_UserTypes = forwardRef(({
    maxTags = undefined,
    // style = '',
    style={},        // container style
    tagStyle={},  // tags
    inputStyle={}, // input field



    defaultTags = [],
    selectedTags = [],
    setSelectedTags = () => {},

    onUserTypeSelect,
    onUserTypeRemove,
    onUserTypeChangeTag,
}, ref) => {
    const placeHolder = "Select User Type";
    // const {usertype:masterUserTypes,ready:usertypeReady} = useUserTypes(); // Assuming this returns the list of property types

    const {userTypes:masterUserTypes,userTypesReady:usertypeReady}= useMasterData();
    

    const tagrefUserType = useRef(null);
    const hasInitialized = useRef(false);

    const [tags, setTags] = useState(defaultTags || []);



/**
     * Resolve UserType IDs or mixed tags into full colony objects from masterUserTypes.
     * @param {Array<number|string|object>} idsOrObjects
     * @param {string} defaultStatus
     * @returns {Array<object>}
     */
    function getObjectFromIds(idsOrObjects ,defaultStatus = "default") {
      if (!Array.isArray(idsOrObjects) || !Array.isArray(masterUserTypes)) return [];
      return idsOrObjects
        .map(tagOrId => {
          if (tagOrId && typeof tagOrId === 'object' && 'id' in tagOrId && 'usertype' in tagOrId) {
            return tagOrId;
          }
          const rawId = typeof tagOrId === 'string' && /^\d+$/.test(tagOrId)
            ? parseInt(tagOrId, 10)
            : tagOrId;
          return masterUserTypes.find(col => {
            const cid = col.id;
            return (
              (typeof cid === 'number' && cid === rawId) ||
              (typeof cid === 'string' && cid === ('' + rawId))
            );
          });
        })
        .filter(Boolean)
        .map(ut => ({
          ...ut,
          status: defaultStatus
        }));
      }



useEffect(() => {
  if (
    !hasInitialized.current &&
    Array.isArray(defaultTags) &&
    defaultTags.length > 0 &&
    tagrefUserType.current &&
    usertypeReady && // ensure masterColonies are loaded
    Array.isArray(masterUserTypes) &&
    masterUserTypes.length > 0
  ) {
    // console.log("masterColonies:", masterColonies);
    // console.log("defaultTags:", defaultTags);

    const initialTags = getObjectFromIds(defaultTags)

    tagrefUserType.current.setTags(initialTags);
    hasInitialized.current = true;
    // console.log("✅ setTags called with:", initialTags);
  }
}, [defaultTags?.length, usertypeReady, masterUserTypes]);









        // useEffect(() => {
        //     if (!hasInitialized.current && defaultTags && defaultTags.length > 0 && tagrefUserType.current) {
        //         tagrefUserType.current.setTags(defaultTags);
        //         hasInitialized.current = true;
        //         // console.log("✅ setTags called with:", defaultTags);
        //     }
        // }, [defaultTags?.length]);




    // Update tags when defaultTags changes
    // useEffect(() => {
    //     setTags(defaultTags || []);
    // }, [defaultTags]);

    // Debugging: Log defaultTags and masterUserTypes
    // useEffect(() => {
    //     // console.log("defaultTags in Comp_UserTypes:", defaultTags);
    //     // console.log("masterUserTypes in Comp_UserTypes:", masterUserTypes);
    // }, [defaultTags, masterUserTypes]);

    const handleSelectTag = (tag) => {
        if (onUserTypeSelect) {
            onUserTypeSelect(tag);
        }
    };

    const handleRemoveTag = (tag) => {
        if (onUserTypeRemove) {
            onUserTypeRemove(tag);
        }
    };

    const handleChangeTag = (AllTags) => {
        if (onUserTypeChangeTag) {
            onUserTypeChangeTag(AllTags);
        }
    };

    // Expose methods using ref
    useImperativeHandle(ref, () => ({
        // getUserTypeTags: () => tagrefUserType.current.getTags(),
        // setUserTypeTags: (selected) => tagrefUserType.current.setTags(selected),
        getObjectFromIds,
        getUserTypeTags: () => selectedTags,
        setUserTypeTags: (tags) => setSelectedTags(tags),   
        getTagsbyIds: (ids) => getTags(ids)
    }));

    function getTags(ids) {
        if (ids.length > 0) {
            return masterUserTypes.filter(record => ids.includes(record.id));
        } else {
            return [];
        }
    }

    return (
        <div>
            <ComponentTagSelector
                ref={tagrefUserType}
                // style={style}
                style={style}        // container style
                tagStyle={tagStyle}  // tags
                inputStyle={inputStyle} // input field

                
                
                suggestions={masterUserTypes} // Ensure this is populated
                defaultTags={tags} // Use internal state for defaultTags
                maxTags={maxTags}
                selectedTags={selectedTags}
                setSelectedTags={setSelectedTags}
                



                displayKey="usertype" // Ensure this matches the key in masterUserTypes
                allowFreeAdd={false}
                placeHolder={placeHolder}
                onSelectTag={handleSelectTag}
                onRemoveTag={handleRemoveTag}
                onChangeTag={handleChangeTag}
            />
            {/* Render tags */}
            {tags.map((tag) => (
                <span key={tag.id}>{tag.name}</span>
            ))}
        </div>
    );
});

export default Comp_UserTypes;
